import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addnewgrievance } from '../../actions/profile';

const AddGrievance = ({ 
  addnewgrievance,
  auth: { user },
  profile: {profile, gid}

}) => {

  useEffect(() => {
    window.scrollTo(0,0);
    
  }, []);

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gt: '', tfcc: '', tfcln: '', ctn: '', ctm: '', ctrel: '', flag: false
  });

  const { gt, tfcln, ctm, ctn, ctrel, flag } = formData;

  if(profile === null)
  {
    navigate('/dashboard');
  }

  const goNext = () => {
    //clearProfile(history, "3");
    navigate("/upload");
  };

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <section className="container">
      <div style={{textAlign: 'center'}}>
        <h4> Application number: {profile._aid} </h4>
        <h4> Name: {profile._n} </h4>
        </div>

      <h2 className="text-danger">Add New Grievance</h2>
      <small> Step 1 : Enter the grievance correctly. In case of any corrections, specify which data is to be changed, and provide new value. Raise multiple grievances if required.</small>
      <br/><small> Step 2 : After entering data and clicking submit, upload the request letter received </small>
      <br/><small> Step 3 : Kindly wait until the upload is complete and filename is shown </small>
      <br/><small> Step 4 : Click Go back in upload screen and check whether all details entered are shown in grievances. </small>
      <br/><small> *** Upload Candidate Request Letter along with proof as a single PDF ***</small>

      {/* <p className="lead">
        <i className="fas fa-code-branch" /> Add any developer/programming
        positions that you have had in the past
      </p>
      <small>* = required field</small> */}
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
          var tobesent = {};
          tobesent.gt = formData.gt;
          tobesent.ctm = formData.ctm;
          tobesent.ctn = formData.ctn;
          tobesent.ctrel = formData.ctrel;
          tobesent.tfcln = formData.tfcln;
          tobesent.tfcc = user && user.tfccode;
          tobesent.n = profile && profile._n;
          tobesent._aid = profile && profile._aid;
          console.log(tobesent);
          if(Number(tobesent.ctm) > 1111111111 && Number(tobesent.ctm < 9999999999))
            addnewgrievance(tobesent, navigate);
          else
            alert("Enter Valid Mobile Number");
          //formData.flag = true;
        }}
      >

      <div className="form-group">
          <textarea
            name="gt"
            cols="40"
            rows="3"
            placeholder="Describe the grievance"
            value={gt}
            onChange={onChange}
            required = {true}
          />
          <small style={{color: "cornflowerblue"}}>describe the grievance</small>
        </div>

        <div className="form-group">
          <input
            type="text"
            placeholder="* Contact Person Name"
            name="ctn"
            value={ctn}
            onChange={onChange}
            required = {true}
          />
          <small style={{color: "cornflowerblue"}}>contact details - name</small>
        </div>
        <div className="form-group">
          <input
            type="text"
            placeholder="* Contact Person Mobile Number"
            name="ctm"
            min={1111111111}
            max={9999999999}
            value={ctm}
            onChange={onChange}
            required = {true}
          />
          <small style={{color: "cornflowerblue"}}>contact details - mobile number</small>
        </div>
     
        <div className="form-group">
          <input
            type="text"
            placeholder="* Relation to candidate "
            name="ctrel"
            value={ctrel}
            onChange={onChange}
            required
          />
          <small style={{color: "cornflowerblue"}}>contact person - relation to candidate</small>
        </div>

        <div className="form-group">
          <input
            type="text"
            placeholder="* Name of TFC Representative "
            name="tfcln"
            value={tfcln}
            onChange={onChange}
            required
          />
          <small style={{color: "cornflowerblue"}}>Name of the TFC Representative</small>
        </div>
        
        <input type="submit" className="btn btn-primary my-1" />        

        {gid !== null && gid !== undefined &&

        
          <input type="submit"  value="Upload Request Letter" className="btn btn-dark" onClick= {e => goNext(e)} />    
        
        }
     
      </form>
    </section>
  );
};

AddGrievance.propTypes = {
  addnewgrievance: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  { addnewgrievance }
)(AddGrievance);


// export default connect(null, { AddGrievance })(addnewgrievance);
